import { mapGetters } from 'vuex';
import { ContactProfileEnum } from '@gid/models';

export default {
  computed: {
    ...mapGetters(['contactProfiles']),
    canManageProjectOwner() {
      return this.contactProfiles.some((p) =>
        [
          ContactProfileEnum.ADMIN,
          ContactProfileEnum.PROJECT_MANAGER_DEFAULT,
          ContactProfileEnum.PROJECT_MANAGER_GENERIC,
        ].includes(p),
      );
    },
  },
};
